import { render, staticRenderFns } from "./Pokemon.vue?vue&type=template&id=8b64175e&scoped=true"
import script from "./Pokemon.vue?vue&type=script&lang=js"
export * from "./Pokemon.vue?vue&type=script&lang=js"
import style0 from "./Pokemon.vue?vue&type=style&index=0&id=8b64175e&prod&lang=css"
import style1 from "./Pokemon.vue?vue&type=style&index=1&id=8b64175e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b64175e",
  null
  
)

export default component.exports